// hyperlink
export const GET_HYPERLINK_BY_ID_REQUESTED = 'GET_HYPERLINK_BY_ID_REQUESTED';
export const GET_HYPERLINK_BY_ID_SUCCESS = 'GET_HYPERLINK_BY_ID_SUCCESS';
export const GET_HYPERLINK_BY_ID_FAILED = 'GET_HYPERLINK_BY_ID_FAILED';
export const ADD_NEW_HYPERLINK_REQUESTED = 'ADD_NEW_HYPERLINK_REQUESTED';
export const ADD_NEW_HYPERLINK_SUCCESS = 'ADD_NEW_HYPERLINK_SUCCESS';
export const ADD_NEW_HYPERLINK_FAILED = 'ADD_NEW_HYPERLINK_FAILED';
export const CLEAR_HYPERLINK = 'CLEAR_HYPERLINK';

// vaultRequest
export const GET_VAULT_REQUEST_BY_ID_REQUESTED =
  'GET_VAULT_REQUEST_BY_ID_REQUESTED';
export const GET_VAULT_REQUEST_BY_ID_SUCCESS =
  'GET_VAULT_REQUEST_BY_ID_SUCCESS';
export const GET_VAULT_REQUEST_BY_ID_FAILED = 'GET_VAULT_REQUEST_BY_ID_FAILED';
export const DELETE_VAULT_REQUEST_REQUESTED = 'DELETE_VAULT_REQUEST_REQUESTED';
export const DELETE_VAULT_REQUEST_SUCCESS = 'DELETE_VAULT_REQUEST_SUCCESS';
export const DELETE_VAULT_REQUEST_FAILED = 'DELETE_VAULT_REQUEST_FAILED';
export const UPDATE_VAULT_REQUEST_REQUESTED = 'UPDATE_VAULT_REQUEST_REQUESTED';
export const UPDATE_VAULT_REQUEST_SUCCESS = 'UPDATE_VAULT_REQUEST_SUCCESS';
export const UPDATE_VAULT_REQUEST_FAILED = 'UPDATE_VAULT_REQUEST_FAILED';
export const ADD_NEW_VAULT_REQUEST_REQUESTED =
  'ADD_NEW_VAULT_REQUEST_REQUESTED';
export const ADD_NEW_VAULT_REQUEST_SUCCESS = 'ADD_NEW_VAULT_REQUEST_SUCCESS';
export const ADD_NEW_VAULT_REQUEST_FAILED = 'ADD_NEW_VAULT_REQUEST_FAILED';
export const CLEAR_VAULT_REQUEST = 'CLEAR_VAULT_REQUEST';

// cardDetails
export const SET_CARD_DETAILS = 'SET_CARD_DETAILS';
export const CLEAR_CARD_DETAILS = 'CLEAR_CARD_DETAILS';

// Buyer contact
export const DELETE_BUYER_CONTACT_REQUESTED = 'DELETE_BUYER_CONTACT_REQUESTED';
export const DELETE_BUYER_CONTACT_SUCCESS = 'DELETE_BUYER_CONTACT_SUCCESS';
export const DELETE_BUYER_CONTACT_FAILED = 'DELETE_BUYER_CONTACT_FAILED';
export const ADD_NEW_BUYER_CONTACT_REQUESTED = 'ADD_NEW_CONTACT_REQUESTED';
export const ADD_NEW_BUYER_CONTACT_SUCCESS = 'ADD_NEW_CONTACT_SUCCESS';
export const ADD_NEW_BUYER_CONTACT_FAILED = 'ADD_NEW_CONTACT_FAILED';
export const UPDATE_BUYER_CONTACT_REQUESTED = 'UPDATE_CONTACT_REQUESTED';
export const UPDATE_BUYER_CONTACT_SUCCESS = 'UPDATE_CONTACT_SUCCESS';
export const UPDATE_BUYER_CONTACT_FAILED = 'UPDATE_CONTACT_FAILED';
export const CLEAR_BUYER_CONTACT = 'CLEAR_BUYER_CONTACT';

// vaultingPost
export const VAULT_CARD_REQUESTED = 'VAULT_CARD_REQUESTED';
export const VAULT_CARD_SUCCESS = 'VAULT_CARD_SUCCESS';
export const VAULT_CARD_FAILED = 'VAULT_CARD_FAILED';

// buyerContactList
export const GET_BUYER_CONTACT_LIST_REQUESTED =
  'GET_BUYER_CONTACT_LIST_REQUESTED';
export const GET_BUYER_CONTACT_LIST_SUCCESS = 'GET_BUYER_CONTACT_LIST_SUCCESS';
export const GET_BUYER_CONTACT_LIST_FAILED = 'GET_BUYER_CONTACT_LIST_FAILED';
export const CLEAR_BUYER_CONTACT_LIST_ERROR = 'CLEAR_BUYER_CONTACT_LIST_ERROR';

// vaultRequestList
export const GET_VAULT_REQUEST_LIST_REQUESTED =
  'GET_VAULT_REQUEST_LIST_REQUESTED';
export const GET_VAULT_REQUEST_LIST_SUCCESS = 'GET_VAULT_REQUEST_LIST_SUCCESS';
export const GET_VAULT_REQUEST_LIST_FAILED = 'GET_VAULT_REQUEST_LIST_FAILED';
export const CLEAR_VAULT_REQUEST_LIST_ERROR = 'CLEAR_VAULT_REQUEST_LIST_ERROR';
export const CLEAR_VAULT_REQUEST_LIST = 'CLEAR_VAULT_REQUEST_LIST';

// contactSearchCriteria
export const SET_CONTACT_SEARCH_CRITERIA = 'SET_CONTACT_SEARCH_CRITERIA';
export const CLEAR_CONTACT_SEARCH_CRITERIA = 'CLEAR_CONTACT_SEARCH_CRITERIA';

// vaultRequestSearchCriteria
export const SET_VAULTING_REQUESTS_SEARCH_CRITERIA =
  'SET_VAULTING_REQUESTS_SEARCH_CRITERIA';
export const CLEAR_VAULTING_REQUESTS_SEARCH_CRITERIA =
  'CLEAR_VAULTING_REQUESTS_SEARCH_CRITERIA';

// contactRecords
export const SET_CONTACT_RECORDS_CURRENT_PAGE =
  'SET_CONTACT_RECORDS_CURRENT_PAGE';

// buyerRecords
export const GET_FILTERED_BUYER_RECORDS_REQUESTED =
  'GET_FILTERED_BUYER_RECORDS_REQUESTED';
export const GET_FILTERED_BUYER_RECORDS_FAILED =
  'GET_FILTERED_BUYER_RECORDS_FAILED';
export const GET_FILTERED_BUYER_RECORDS_SUCCESS =
  'GET_FILTERED_BUYER_RECORDS_SUCCESS';
export const CLEAR_FILTERED_BUYER_RECORDS_ERROR =
  'CLEAR_FILTERED_BUYER_RECORDS_ERROR';

// supplierRecords
export const GET_FILTERED_SUPPLIER_RECORDS_REQUESTED =
  'GET_FILTERED_SUPPLIER_RECORDS_REQUESTED';
export const GET_FILTERED_SUPPLIER_RECORDS_FAILED =
  'GET_FILTERED_SUPPLIER_RECORDS_FAILED';
export const GET_FILTERED_SUPPLIER_RECORDS_SUCCESS =
  'GET_FILTERED_SUPPLIER_RECORDS_SUCCESS';
export const CLEAR_FILTERED_SUPPLIER_RECORDS_ERROR =
  'CLEAR_FILTERED_SUPPLIER_RECORDS_ERROR';

// userActs
export const GET_USER_ACT_LIST_REQUESTED = 'GET_USER_ACT_LIST_REQUESTED';
export const GET_USER_ACT_LIST_FAILED = 'GET_USER_ACT_LIST_FAILED';
export const GET_USER_ACT_LIST_SUCCESS = 'GET_USER_ACT_LIST_SUCCESS';
export const CLEAR_USER_ACTS_LIST_ERROR = 'CLEAR_USER_ACTS_LIST_ERROR';

// userActSearchCriteria
export const SET_USER_ACT_SEARCH_CRITERIA = 'SET_USER_ACT_SEARCH_CRITERIA';
export const CLEAR_USER_ACT_SEARCH_CRITERIA = 'CLEAR_USER_ACT_SEARCH_CRITERIA';

// userActivity
export const SET_USER_ACTIVITY_CURRENT_PAGE = 'SET_USER_ACTIVITY_CURRENT_PAGE';

// vaultActs
export const GET_VAULT_ACT_LIST_REQUESTED = 'GET_VAULT_ACT_LIST_REQUESTED';
export const GET_VAULT_ACT_LIST_FAILED = 'GET_VAULT_ACT_LIST_FAILED';
export const GET_VAULT_ACT_LIST_SUCCESS = 'GET_VAULT_ACT_LIST_SUCCESS';
export const CLEAR_VAULT_ACTS_LIST_ERROR = 'CLEAR_VAULT_ACTS_LIST_ERROR';

// vaultActSearchCriteria
export const SET_VAULT_ACT_SEARCH_CRITERIA = 'SET_VAULT_ACT_SEARCH_CRITERIA';
export const CLEAR_VAULT_ACT_SEARCH_CRITERIA =
  'CLEAR_VAULT_ACT_SEARCH_CRITERIA';

// vaultingActivity
export const SET_VAULTING_ACTIVITY_CURRENT_PAGE =
  'SET_VAULT_ACTIVITY_CURRENT_PAGE';

// supplierSecrets
export const GET_SUPPLIER_SECRETS_REQUESTED = 'GET_SUPPLIER_SECRETS_REQUESTED';
export const GET_SUPPLIER_SECRETS_FAILED = 'GET_SUPPLIER_SECRETS_FAILED';
export const GET_SUPPLIER_SECRETS_SUCCESS = 'GET_SUPPLIER_SECRETS_SUCCESS';
export const CLEAR_SUPPLIER_SECRETS = 'CLEAR_SUPPLIER_SECRETS';

// vaultingRequests
export const SET_VAULTING_REQUESTS_CURRENT_PAGE =
  'SET_VAULTING_REQUESTS_CURRENT_PAGE';

// user
export const SET_USER_AUTHENTICATED = 'SET_USER_AUTHENTICATED';
export const SET_USER_LOADING = 'SET_USER_LOADING';
